var React = require('react');

function LinkArrow (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:none;}\r\n"),React.createElement("polygon",{"className":"st0","points":"4.3,23 1.5,20.2 10.2,11.6 1.5,3 4.3,0.2 16,11.6 ","key":1})]);
}

LinkArrow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16.1 23.1","style":{"enableBackground":"new 0 0 16.1 23.1"},"xmlSpace":"preserve"};

module.exports = LinkArrow;

LinkArrow.default = LinkArrow;
